import {useCallback,useEffect,useState} from 'react';
export function useGalleryAvailability(enabled=true){
 const [result,setResult]=useState({data:null,loading:enabled,error:false});
 const [attempt,setAttempt]=useState(0);
 const retry=useCallback(()=>{setResult(current=>({...current,loading:true,error:false}));setAttempt(current=>current+1);},[]);
 useEffect(()=>{
  if(!enabled)return;
  let current=true; const controller=new AbortController();
  setResult({data:null,loading:true,error:false});
  fetch('/api/di-barbieri-gallery/public',{signal:controller.signal}).then(response=>{if(!response.ok)throw Error('Gallery unavailable');return response.json();}).then(data=>{if(current)setResult({data,loading:false,error:false});}).catch(error=>{if(current&&error.name!=='AbortError')setResult({data:null,loading:false,error:true});});
  return ()=>{current=false;controller.abort();};
 },[enabled,attempt]);
 return {...result,loading:result.loading || (enabled&&!result.data&&!result.error),retry};
}
